
export enum LincolnshireRecordType  {           
        Monument = "mon",     
        Event = "event", 
        Source = "source",
        Designation= "desig"
}  

export enum LincolnshireRecordSubType  {   
    ConservationArea = "COA",
    ListedBuilding = "LB",
    RegisteredParkAndGarden = "RG",
    ScheduledMonument = "SAM",
    RegisteredBattlefield = "RB",
    ExtensiveUrbanSurvey = "EUS"
}  
